import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import { ImageEditForm } from '@/components/features/images'
import { AnalyticsService } from '@/services/analytics'

export function ImageEditPage() {
  const { user } = useUser()

  useEffect(() => {
    AnalyticsService.trackViewItem('image_tools', 'image_edit', 'Image Edit', user?.id)
    AnalyticsService.trackViewContent('Image Edit', user?.id)
  }, [user?.id])

  return (
    <div className="p-6 md:p-8 max-w-4xl mx-auto">
      <ImageEditForm />
    </div>
  )
}
